import { Card, styled } from '@mui/material';

export const SearchResultFamilyProviderStyled = styled('div')({
  marginTop: '12px',
});

export const ProviderFamilyBoxStyled = styled(Card)({
  width: 'fit-content',
  borderRadius: '4px',
  height: 'fit-content',
});
